module.exports = __webpack_public_path__ + "media/app/assets/specializations/paladin/protection-5693e4cdd61721cc54f20b78dfb21495.png";